import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ClipboardList, ArrowRight } from "lucide-react";
import { executorMode } from "../lib/api";
import { tr } from "../lib/i18n";

// Dashboard entry: shown for vaults created from /executor, or once any timeline task is ticked.
export const ExecutorModeCard = () => {
  const { data } = useQuery({ queryKey: ["executor-mode"], queryFn: executorMode, staleTime: 120000 });
  if (!data || (!data.from_landing && !data.done && !data.profile?.deceased_name)) return null;
  return (
    <Link to="/executor-mode" className="mb-6 flex items-center gap-4 rounded-2xl border border-primary/30 bg-primary/5 p-4 hover:border-primary transition-colors" data-testid="executor-mode-card">
      <span className="h-10 w-10 rounded-xl bg-primary/10 text-primary grid place-items-center shrink-0"><ClipboardList className="h-5 w-5" /></span>
      <div className="flex-1 min-w-0"><div className="font-medium">{tr("Executor Mode")}{data.profile?.deceased_name ? ` · ${data.profile.deceased_name}` : ""}</div><div className="text-xs text-muted-foreground">{data.done}/{data.total} {tr("steps done")}{data.purchased ? "" : ` · ${tr("unlock unlimited documents for")} $${data.price}`}</div></div>
      <ArrowRight className="h-4 w-4 text-primary shrink-0" />
    </Link>
  );
};
